<glxy-form-field [hideRequiredLabel]="true">
  <glxy-label>{{ label }}</glxy-label>
  <input
    matInput
    [formControl]="control"
    autocomplete="{{ disableAutoComplete }}"
    [placeholder]="'OPPORTUNITY.CREATE_PAGE.NAME_PLACEHOLDER' | translate"
  />
  <glxy-error *ngIf="!control.untouched && control?.hasError('required')">
    {{ 'STANDARD_FIELD_RULES.OPPORTUNITY.OPPORTUNITY_NAME_REQUIRED' | translate }}
  </glxy-error>
</glxy-form-field>
